// Site navigation, shared by the header, footer, sitemap page, 404 page and related-services strip.

export const services = [
    { href: '/ai-ml-services', text: 'AI & Automation', description: 'Automate the repetitive work' },
    { href: '/sw-dev-services', text: 'Custom Software', description: 'Software built around how you work' },
    { href: '/web-dev-services', text: 'Websites & Web Apps', description: 'A website that brings in business' },
    { href: '/simulations-services', text: 'Simulation & Digital Twins', description: 'Test big decisions before you make them' },
]

// Header links before the Services dropdown
export const headerLinks = [
    { href: '/about', text: 'About Us' },
    { href: '/case-studies', text: 'Case Studies' },
]

export const companyLinks = [
    { href: '/about', text: 'About' },
    { href: '/case-studies', text: 'Case Studies' },
    ...services,
    { href: '/contact', text: 'Contact' },
]

export const legalLinks = [
    { href: '/privacy-policy', text: 'Privacy Policy' },
    { href: '/terms-and-conditions', text: 'Terms & Conditions' },
    { href: '/sitemap', text: 'Sitemap' },
]

export const socialLinks = [
    { href: 'https://www.facebook.com/people/Mallard-Technologies/61566426144666/', text: 'Facebook' },
    { href: 'https://www.linkedin.com/company/mallard-technologies/?viewAsMember=true', text: 'LinkedIn' },
]
